/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  Navbar,
  Nav,
  Container,
} from "reactstrap";
import UserMenu from "../UserMenu";

const AdminNavbar = (props) => {
  return (
    <>
      <Navbar 
        className="navbar-top navbar-dark d-none d-md-block" 
        expand="md" 
        id="navbar-main" 
        style={{ 
          background: 'linear-gradient(135deg, #5A0C62 0%, #DC017F 100%)',
          minHeight: '70px'
        }}
      >
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex align-items-center">
              <div
                style={{
                  backgroundColor: "#eee",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  marginRight: "15px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/imagenes/terminales/" +
                    (props.terminalLogo || "logo_emp.png")
                  }
                  alt="Logo Terminal"
                  style={{
                    height: "50px",
                    width: "auto",
                    objectFit: "contain"
                  }}
                />
              </div>

              {/* Lado izquierdo - Título y Descripción */}
                <div>
                  <span
                    className="h4 mb-0 text-white text-uppercase d-block"
                    style={{ fontSize: "1.1rem" }}
                  >
                    {props.brandDescription}
                  </span>

                  {props.brandDescription && (
                    <span
                      className="text-white text-lg font-weight-light d-block mt-1"
                      style={{ opacity: 0.9 }}
                    >
                      {props.brandText}
                    </span>
                  )}
                </div>
              </div>

              {/* Centro y lado derecho - Usuario */}
              <Nav className="align-items-center d-none d-lg-flex" navbar>
                <UserMenu variant="default" />
              </Nav>
            </div>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
